import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMfaLabelsOptions } from 'src/apps/mfa/services/MfaDashboardService';
import { IMfaLabelOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { MFA_LABELS_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMfaLabelsOptionsQuery = (): UseQueryResult<IMfaLabelOptions[]> => {
	return useQuery([MFA_LABELS_OPTIONS], () => getMfaLabelsOptions());
};
